import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/useAuth";
import { can } from "../auth/can";
import NotFound from "./NotFound";

export default function ProtectedRoute({ permission, children }) {
  const { permissions } = useAuth();

  
  if (!can(permissions, permission)) {
    return <Navigate to="/403" replace />;
  }

 
  if (children == null || children === false) {
    return <NotFound />;
  }

  return children;
}